import React from 'react';

// Compact stepper cell for one of the six D&D ability scores. Renders the
// label, the current value with -/+ steppers, and the derived 5e modifier.
// Shared between LevelUpOverlay and CharacterSetup so both edit-surfaces
// look and behave identically.
export default function AbilityScoreCell({ label, value, onChange, min = 1, max = 30 }) {
  const v = value || 10;
  const mod = Math.floor((v - 10) / 2);
  const modText = mod >= 0 ? `+${mod}` : `${mod}`;
  return (
    <div style={styles.cell}>
      <div style={styles.label}>{label}</div>
      <div style={styles.row}>
        <button style={styles.btn} onClick={() => onChange(Math.max(min, v - 1))}>−</button>
        <span style={styles.value}>{v}</span>
        <button style={styles.btn} onClick={() => onChange(Math.min(max, v + 1))}>+</button>
      </div>
      <div style={styles.mod}>{modText}</div>
    </div>
  );
}

const styles = {
  cell:  { background: '#0e1528', border: '1px solid #4a3d28', borderRadius: 4, padding: '6px 4px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 },
  label: { fontSize: 9, fontWeight: 800, color: '#9a8b6e', letterSpacing: '0.08em' },
  row:   { display: 'flex', alignItems: 'center', gap: 0 },
  btn:   { width: 24, height: 24, background: 'transparent', border: 'none', color: '#d4a847', fontSize: 14, fontWeight: 800, cursor: 'pointer', padding: 0, lineHeight: 1 },
  value: { minWidth: 24, textAlign: 'center', fontSize: 16, fontWeight: 800, color: '#f0e6d0' },
  mod:   { fontSize: 10, fontWeight: 700, color: '#7ab8e0' },
};
